module.exports = __webpack_public_path__ + "img/0044.ad57fa11.png";